import { inject, Injectable } from '@angular/core';
import { VacationWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  HeaderFooterMachCore,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BookingVacationCertificatesService {
  private userSessionService = inject(UserSessionService);

  resolveCertificatesLinkUrl(
    widgetContent: VacationWidget,
    aem: HeaderFooterMachCore,
    vacationWidgetContent$: BehaviorSubject<VacationWidget>
  ): void {
    const certificatesAem = aem.header?.book?.vacations?.certificatesLink;
    this.userSessionService
      .getUserSession()
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const url = response?.loggedIn
            ? certificatesAem?.loggedInUrl
            : certificatesAem?.loggedOutUrl;
          const updated = {
            ...widgetContent,
            certificatesLink: { url: url || '/redeem-ecredit/' }
          };
          vacationWidgetContent$.next(updated);
        },
        error: () => {
          const updated = {
            ...widgetContent,
            certificatesLink: { url: certificatesAem?.loggedOutUrl || '' }
          };
          vacationWidgetContent$.next(updated);
        }
      });
  }
}
